import React from "react"
import {CondDateTimePicker} from "../index";
import moment from "moment/moment";

const SearchContainer = ({children}) => (
    <div className="search-container">
        {children}
    </div>
)

/**
 * 검색 기준 창의 한 행
 * @param children
 * @returns {React.JSX.Element}
 * @constructor
 */
const SearchRow = ({ children }) => (
    <div className="search-row">
        {children}
    </div>
);

/**
 * 검색 기준 행 내 Label
 * @param children
 * @returns {React.JSX.Element}
 * @constructor
 */
const SearchLabel = ({ text }) => (
    <div className="search-label">
        {text}
    </div>
);


/**
 * 검색 기준 행 내 Content
 * @param children
 * @param style
 * @returns {React.JSX.Element}
 * @constructor
 */
const SearchContent = ({ children, style }) => (
    <div className="search-content" style={style}>
        {children}
    </div>
);


function handleDateShortcutClick (endAt, days, setStartAt, setEndAt) {
    const startDate = moment(endAt).subtract(days, 'days').hour(0).minute(0).second(0);
    setStartAt(startDate.format('YYYY-MM-DDTHH:mm:ss'));
    setEndAt(moment.utc().hour(23).minute(59).second(59).format("YYYY-MM-DDTHH:mm:ss"));
}

/**
 * 날짜 범위 선택 컴포넌트
 * @param startAt
 * @param endAt
 * @param setStartAt
 * @param setEndAt
 * @param shortcuts - 날짜 단축키로 사용할 일수 배열
 * @returns {Element}
 * @constructor
 */
const SearchDateRange = ({ startAt, endAt, setStartAt, setEndAt, shortcuts = [3, 7, 15, 30, 90] }) => {
    return (
        <div className="date-range">
            <CondDateTimePicker
                disable={false}
                value={startAt}
                onChange={setStartAt}
            />

            <div className="date-separator">~</div>

            <CondDateTimePicker
                disable={false}
                value={endAt}
                onChange={setEndAt}
            />

            {shortcuts && (
                <div className="date-shortcuts">
                    {shortcuts.map((days) => {
                        {/* 서버에서 90일 이상 검색은 허용하지 않아서 임시로 처리함*/}
                        if(days >= 90){
                            days = 89;
                        }

                        return (
                            <button key={days} onClick={() => handleDateShortcutClick(endAt, days, setStartAt, setEndAt)}>
                                {/* 서버에서 90일 이상 검색은 허용하지 않아서 임시로 처리함*/}
                                {days === 89 ? 90 : days}일
                            </button>
                        )
                        })
                    }
                </div>
            )}
        </div>
    )
}


/**
 *
 * @param handleSearchClick - 조회 함수
 * @param handleResetClick - 초기화 함수
 * @returns {React.JSX.Element}
 * @constructor
 */
const SearchBtnContainer = ({ handleSearchClick, handleResetClick }) => (
    <div className="btn-container">
        <button className="defaultBtn" onClick={handleSearchClick}>조회</button>
        <button className="outlineBtn" onClick={handleResetClick}>초기화</button>
    </div>
)

const SearchBtn = ({ handleSearchClick }) => (
    <button style={{alignSelf: "center"}} className="defaultBtn" onClick={handleSearchClick}>조회</button>
)


export {
    SearchContainer,
    SearchRow,
    SearchLabel,
    SearchContent,
    SearchDateRange,
    SearchBtn,
    SearchBtnContainer
}